import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_noseSinuses_redFlagSymptoms',
    label: 'Are you experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Eye protrusion or abnormal eye movements',
          key: 'eye_protrusion_abnormal_movements'
        },
        { value: 'Sudden vision changes', key: 'sudden_vision_changes' },
        {
          value: 'Severe headache with neck stiffness',
          key: 'severe_headache_neck_stiffness'
        },
        {
          value: 'Facial swelling or redness',
          key: 'facial_swelling_redness'
        },
        {
          value: 'Altered mental status or feeling severely ill',
          key: 'altered_mental_status'
        },
        {
          value: 'Recent head or facial injury',
          key: 'recent_head_facial_injury'
        },
        {
          value: 'Recent head or facial surgery',
          key: 'recent_head_facial_surgery'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_sinusitisEpisodes',
    label:
      'Have you had 4 or more episodes of bacterial sinusitis within a 12-month period that were diagnosed by a physician?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'High fever (≥102°F)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_symptoms',
    label: 'Which symptoms are you experiencing? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Stuffy or runny nose', key: 'stuffy_runny_nose' },
        {
          value: 'Yellow or green mucus (from nose or draining down throat)',
          key: 'yellow_green_mucus'
        },
        {
          value: 'Decreased or lost sense of smell',
          key: 'decreased_lost_smell'
        },
        { value: 'Headache', key: 'headache' },
        {
          value: 'Clear or thin nasal discharge',
          key: 'clear_thin_discharge'
        },
        { value: 'Pain in upper teeth', key: 'upper_teeth_pain' },
        { value: 'Facial pain or pressure', key: 'facial_pain' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_facialPainSide',
    label: 'Is your facial pain mostly on:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'One side', key: 'one_side' },
        { value: 'Both sides', key: 'both_sides' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_symptomDuration',
    label: 'How long have your sinus symptoms been present?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 3 days', key: 'less_than_3_days' },
        { value: '3–6 days', key: '3_to_6_days' },
        { value: '7–9 days', key: '7_to_9_days' },
        { value: '10 days or more', key: '10_days_or_more' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_symptomChange',
    label: 'How have your symptoms changed over time?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Steadily improving', key: 'improving' },
        { value: 'About the same', key: 'same' },
        { value: 'Getting worse', key: 'worse' },
        {
          value: 'Improved, then worsened again ("Double-sickening")',
          key: 'double_sickening'
        }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_coldOrFluStart',
    label: 'Did your symptoms start with a cold or flu-like illness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_antibioticsTaken',
    label: 'Have you taken any antibiotics for this episode?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_antibioticName',
    label: 'Which antibiotic?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_noseSinuses_antibioticName'
    }
  },
  {
    field: 'zalud_noseSinuses_treatmentsTried',
    label: 'Have you tried any treatments so far? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Saline nasal rinse or spray',
          key: 'saline_nasal_rinse_spray'
        },
        {
          value:
            'Over-the-counter decongestant (e.g., pseudoephedrine, oxymetazoline)',
          key: 'otc_decongestant'
        },
        {
          value: 'Nasal steroid spray (e.g., Flonase, Nasacort)',
          key: 'nasal_steroid_spray'
        },
        {
          value:
            'Over-the-counter pain reliever (e.g., ibuprofen, acetaminophen)',
          key: 'otc_pain_reliever'
        },
        {
          value: 'Other',
          key: 'other',
          answer: {
            type: 'text',
            name: 'zalud_noseSinuses_treatmentsTriedOther',
            placeholder: 'Please specify'
          }
        },
        { value: 'None', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_noseSinuses_additionalComments'
    }
  },
  {
    field: 'zalud_noseSinuses_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_noseSinuses_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_noseSinuses_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludNoseSinusesQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
